import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const DemoLimitationBanner = ({ limitationTitle, limitationDescription }) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between md:p-10 rounded-xl bg-orange-100 Xbg-red-500">
      {/* Icon */}
      <div className="flex flex-[2] flex-row items-center justify-center Xbg-green-500">
        <div className="flex justify-center items-center mt-10 md:mt-0 p-6 Xw-32 Xh-32 Xbg-red-500">
          <ExclamationTriangleIcon className="h-44 w-44 color-neutral-700" />
        </div>
      </div>
      {/* Text */}
      <div className="flex flex-[8] flex-col justify-center items-start p-6 Xbg-purple-500">
        {/* Title */}
        <div>
          <p className="text-2xl font-medium text-neutral-700">
            {limitationTitle}
          </p>
        </div>
        {/* Details */}
        <div>
          <p className="text-lg font-medium text-neutral-700">
            {limitationDescription}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoLimitationBanner;
